<template>
  <div v-if="livros?.length" class="livro-simulacao">
    <p v-for="(livro, index) in livros" :key="index">
      <span v-if="livro.numeroControleLivro != null">
        <span class="font-weight-500">Livro:</span> {{ livro.numeroControleLivro }}
      </span>

      <span v-if="livro.numeroControleFolha">
        <span class="font-weight-500"> Folha:</span> {{ livro.numeroControleFolha }}
      </span>

      <span v-if="livro.ladoPaginaControleInicial">
        {{ livro.ladoPaginaControleInicial }}
      </span>

      <span v-if="livro.numeroControleFolhaFinal">
        - {{ livro.numeroControleFolhaFinal }}
      </span>

      <span v-if="livro.ladoPaginaControleFinal">
        {{ livro.ladoPaginaControleFinal }}
      </span>

      <span v-if="livro.quantidadeFolhas">
        | <span class="font-weight-500">Quantidade de Folhas:</span> {{ livro.quantidadeFolhas }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "LivroSimulacao",
  props: {
    livros: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
  p + .livro-simulacao {
    margin-top: 0.5rem;
  }
</style>
